import styled from 'styled-components';
import {Err} from "../../Step1Setup/styles";
import {
    InputWrapper
  } from "../../Step1Setup/styles";

export const SelectWrap = styled.div`
    .ant-select {
        width: 100%;
    }
`

export const ErrLength = styled(Err).attrs(props => ({
    className: "error-fields-ooa-2"
  }))`
    width: 355px;
    margin-top: -20px;
    letter-spacing: ${props => props.theme.letterSpacing.zero};
    @media only screen and (min-width: 320px) and (max-width: 767px) {
        width: 231px;
    }
`

export const DOBWrap = styled(InputWrapper)`
    .ant-calendar-picker {
      width: 100%;
    }
`

export const MarginSpecific = styled.div`
@media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: ${props => props.marginTop};
    padding-top: ${props => props.paddingTop}
}
    
`

export const MarginWrapperBtn = styled.div`
    margin: 15px 0px;
`;